export default __webpack_public_path__ + "static/media/27.88117821.png";